import * as React from 'react'
import { StatusMessageContainer } from 'uiComponents/messages'
import increaseIcon from './increase.svg'
import decreaseIcon from './decrease.svg'
import noImpactIcon from './equal.svg'
import unknownIcon from './unknown.svg'
import { MessageKind } from 'uiComponents/messages'
import { Impact } from 'http/statsService'

interface PriceEstimateBoxProps {
    variation: Impact | 'incomplete_rule'
}

export function PriceEstimateBox(props: PriceEstimateBoxProps) {
    let iconSrc
    let impactText
    let status: MessageKind
    let genericError = false
    let incompleteRule = false
    switch (props.variation) {
        case 'expected_increase_in_revenue':
            iconSrc = increaseIcon
            impactText = 'Increase in revenue'
            status = 'success'
            break
        case 'expected_decrease_in_revenue':
            iconSrc = decreaseIcon
            impactText = 'Decrease in revenue'
            status = 'error'
            break
        case 'no_significant_change_detected':
            iconSrc = noImpactIcon
            impactText = 'No significant change'
            status = 'warn'
            break
        case 'not_enough_data_to_estimate':
            iconSrc = unknownIcon
            impactText = 'Unknown'
            status = 'unknown'
            break
        case 'generic_error':
            iconSrc = unknownIcon
            genericError = true
            status = 'unknown'
            break
        case 'incomplete_rule':
            iconSrc = unknownIcon
            impactText = 'Unknown'
            incompleteRule = true
            status = 'unknown'
            break
        default:
            iconSrc = unknownIcon
            impactText = 'Unknown'
            status = 'unknown'
            break
    }
    return (
        <StatusMessageContainer title="IMPACT ON REVENUE" iconSrc={iconSrc} status={status}>
            {genericError ? (
                <div>Our servers encountered an unexpected issue, please excuse us and try again later.</div>
            ) : (
                <div>
                    <div style={{ marginBottom: '0.9em' }}>
                        Estimated impact: <strong>{impactText}</strong>
                    </div>
                    {incompleteRule ? (
                        <div>Set up your rule(s) so we can calculate the revenue estimate.</div>
                    ) : (
                        <div>Estimated impact on your revenue when this exception is applied.</div>
                    )}
                </div>
            )}
        </StatusMessageContainer>
    )
}
